/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../theme/theme"
import { css, IconButton, InputAdornment } from "@mui/material"
import { ClockIcon, TimePicker } from "@mui/x-date-pickers"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { useState } from "react"

interface MyTimePickerProps {
    label: string
    value: Date | null
    onChange: (time: Date | null) => void
}

const TimePickerStyle = withMyTheme((theme) => css`
    width: 100%;

    .MuiInputLabel-root {
        background: white;
        padding: 0 6px;     
    }
    
    .MuiOutlinedInput-root {
        border-radius: 12px;
        background-color: white;
        
        &:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
        }
        
        &.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
            border-width: 2px;
        }
    }
    
    .MuiInputLabel-root {
        color: ${theme.palette.text.primary};
        font-size: 1rem;
        
        &.Mui-focused {
            color: ${theme.palette.primary.main};
        }
        
        @media (min-width: 768px) {
            font-size: 1.4rem;
        }
    }
    
    .MuiInputBase-input {
        font-size: 1rem;
        
        @media (min-width: 768px) {
            font-size: 1.4rem;
            padding: 20px 24px;
        }
    }
`)

const TimePickerIconStyle = withMyTheme((theme) => css`
    color: ${theme.palette.primary.main};
`)

export const MyTimePicker = ({ label, value, onChange }: MyTimePickerProps) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
                label={label}
                value={value}
                onChange={onChange}
                format="HH:mm"
                ampm={false}
                css={TimePickerStyle}
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                slotProps={{
                    textField: {
                        // We make the text field clickable to open the picker
                        onClick: () => setIsOpen(true),
                        InputProps: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setIsOpen(true)} css={TimePickerIconStyle}>
                                        <ClockIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }
                    }
                }}
            />
        </LocalizationProvider>
    )
}